/* eslint-disable no-useless-escape */
import { useState, useEffect, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { connect, useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { useTranslation } from "react-i18next";
import { Chart } from "react-google-charts";
import InfiniteScroll from "react-infinite-scroller";
import DOMPurify from "dompurify";
import { getColorByCategory } from "../../helpers/heplers";

import PropTypes from "prop-types";

import {
  Button,
  Card,
  Col,
  Container,
  Dropdown,
  Row,
  Spinner,
  // Row,
} from "react-bootstrap";

import {
  filterMessagesRestarted,
  bookmarkDocument,
  unbookmarkDocument,
  regulatoryStreamsAreClean,
} from "../../actions/filterActions";

import { addArrayAction } from "../../actions/newsListActions";

import { addPageAction } from "../../actions/addPageAction";

import { aIResponseCloseModal } from "../../actions/askQuestion";

import {
  GET_DOCUMENT_BY_ID_AWAITING_ID,
  EARTH_ICON,
} from "../../constants/stringConstants";

import Loader from "../../utils/Loader";
import { formatDate } from "../../utils/formatDate";
import AlertMessage from "../../utils/AlertMessage";
import CustomModal from "../../utils/CustomModal";
import FieldsInForm from "../../utils/FieldsInForm";

import iconsAskAQuestion from "../../assets/png/icons-askAQuestion.png";
import iconsAddToList from "../../assets/svg/icons-addToList.svg";
import iconsClearAll from "../../assets/svg/icons-clearAll.svg";
import iconsManage from "../../assets/svg/icons-manage.svg";
import iconsDelete from "../../assets/svg/icons-delete.svg";
import iconsEdit from "../../assets/svg/icons-edit.svg";
import iconsExternalLink from "../../assets/svg/icons-externalLink.svg";
import iconsSaveFilterSet from "../../assets/svg/icons-saveFilterSet.svg";
import iconsSortUp from "../../assets/svg/icons-sortUp.svg";
import { dateSetter } from "../../utils/DateSetter";
import iconThreeDotsHorizontal from "../../assets/svg/three-dots-horizontal.svg";

import StarBookmark from "./StarBookmark";
import { makeImageSrcByName } from "../../utils/makeImageSrcByName";
import {
  addDocument,
  addLink,
  getTilesOfTypeLinks,
} from "../../actions/tileActions";

const OverviewSmallScreenContainer = ({
  bookmarkDocument,
  unbookmarkDocument,
  userToken,
  loggedIn,
  singleTopic,
  setSortField,
  userRights,
  regulatoryStreamLoadedWithError,
  regulatoryStreamPaginationError,
  showDeleteNewsModal,
  handlePagination,
  filterFailureMessage,
  filterSuccessMessage,
  filterMessagesRestarted,
  filtersAreLoading,
  filtersTypesAreLoading,
  regulatoryStreamAreLoading,
  top5PublishersAreLoading,
  top5CountriesAreLoading,
  graphAggregationsAreLoading,
  hotTopicsAndBusinessUnitsAreLoading,
  filters,
  publicationTypesDataSet,
  publisherTypesDataSet,
  countriesDataSet,
  setCountries,
  setPublicationTypes,
  setPublisherTypes,
  countries,
  publicationTypes,
  publisherTypes,
  setFromDate,
  setToDate,
  setEditNewsModal,
  // setAskAQuestionModal,
  setFreeText,
  setAddNewsModal,
  freeText,
  preparationOfDataBeforeOperation,
  setRaiseSaveFilterModal,
  multiFilterRadioButtonsValue,
  setMultiFilterRadioButtonsValue,
  applyFilter,
  resetParams,
  fromDate,
  toDate,
  setRaiseManageFiltersModal,
  changeRadioButtonValue,
  setChangeRadioButtonValue,
  graphAggregationsTotalAmount,
  top5Publishers,
  top5Countries,
  regulatoryStream,
  graphAggregationsDetailsFormatted,
  setPage,
  tilesOfTypeLinks,
  addLink,
  setSubmitNewsOccurred,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const filtersFormRef = useRef(null);
  const innerScrollRef = useRef(null);
  const history = useHistory();

  const [failureMessage, setFailureMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [optionRemoved, setOptionRemoved] = useState(false);
  const [raiseFiltersModal, setRaiseFiltersModal] = useState(false);
  const [savedFilterSelected, setSavedFilterSelected] = useState("");
  const [sortingFieldValue, setSortingFieldValue] = useState("");

  const [addToListDialogIsShown, setAddToListDialogIsShown] = useState(false);
  const [selectedNew, setSelectedNew] = useState();
  const [tile, setTile] = useState(
    tilesOfTypeLinks.length > 0 ? tilesOfTypeLinks[0] : 0
  );
  const [submitOccurred, setSubmitOccurred] = useState(false);
  const [askAQuestionModal, setAskAQuestionModal] = useState(false);

  useEffect(() => {
    if (tilesOfTypeLinks.length && !tile) {
      setTile(tilesOfTypeLinks[0]);
    }
  }, [tilesOfTypeLinks, tile]);

  const argsForAddListDialog = {
    findFormErrors: () => {
      const newErrors = {};

      if (!tile.TILE_ID)
        newErrors.TILE_ID = t("optionMustBeSelectedFromDropdown");

      return newErrors;
    },
    fields: [
      {
        name: "TILE_ID",
        type: "select",
        options: tilesOfTypeLinks,
        required: true,
        displayProperty: "TILE_NAME",
        valueProperty: "TILE_ID",
        label: t("selectList"),
        value: tile.TILE_ID,
      },
    ],
    classNameReactFormal: "register-login-react-formal",
    classNameForm: "register-login-react-form",
    onSelectBoxChanged: (TILE_ID) => {
      setTile(tilesOfTypeLinks.find((t) => t.TILE_ID === +TILE_ID) ?? 0);
    },
    onSubmit: () => {
      addLink(
        userToken,
        tile.TILE_ID,
        selectedNew?.news_title,
        window.location.href,
        "",
        history.location.state?.from === "search"
          ? undefined
          : singleTopic.TOPIC_ID,
        true
      );
      setTile(tilesOfTypeLinks[0]);
      setAddToListDialogIsShown(false);
      setSelectedNew(undefined);
    },
  };

  const handleScroll = useCallback(() => {
    sessionStorage?.removeItem("savedPage");
  }, []);

  useEffect(() => {
    const div = innerScrollRef.current;
    if (div) {
      div.addEventListener("scroll", handleScroll);
    }
  }, [handleScroll]);

  const getSortType = (sortFiled) => {
    if (sortFiled === "publicationDate") {
      return "news_date";
    }
    if (sortFiled === "publicationType") {
      return "news_type";
    }
    if (sortFiled === "relevance") {
      return "";
    }
    if (sortFiled === "bookmarks") {
      return "bookmarks";
    }
  };

  const [
    changeFieldsInFormRadioButtons,
    setChangeFieldsInFormRadioButtons,
  ] = useState(0);
  // const [sortBy, setSortBy] = useState({ sort: "relevance", reverse: false });
  let sessionSort = JSON.parse(sessionStorage?.getItem("sortBy"));
  const [sortBy, setSortBy] = useState(
    sessionSort ? sessionSort : { sort: "relevance", reverse: false }
  );

  const [showGraph, setShowGraph] = useState(false);
  const [showTop5Publishers, setShowTop5Publishers] = useState(false);
  const [showTop5Countries, setShowTop5Countries] = useState(false);
  const [itemVisibility, setItemVisibility] = useState({});

  const sanitizer = DOMPurify.sanitize;

  const toggleVisibility = (id) => {
    setItemVisibility((prevVisibility) => ({
      ...prevVisibility,
      [id]: !prevVisibility[id],
    }));
  };

  const revelanceSort = () => {
    setSortField("");
    setSortBy((prev) => ({
      sort: "relevance",
      // reverse: prev.sort === "relevance" ? !prev.reverse : false,
      reverse: prev.sort === "relevance" ? prev.reverse : false,
    }));
    dispatch(addArrayAction([]));
    setStoredData([]);
    dispatch(addPageAction(null));
    sessionStorage?.removeItem("savedPosition");
    sessionStorage?.removeItem("savedPage");
  };

  const newsDateSort = () => {
    setSortField("news_date");
    setSortBy((prev) => ({
      sort: "publicationDate",
      // reverse: prev.sort === "publicationDate" ? !prev.reverse : false,
      reverse: prev.sort === "publicationDate" ? prev.reverse : false,
    }));
    dispatch(addArrayAction([]));
    setStoredData([]);
    dispatch(addPageAction(null));
    sessionStorage?.removeItem("savedPosition");
    sessionStorage?.removeItem("savedPage");
  };

  const newsTypeSort = () => {
    setSortField("news_type");
    setSortBy((prev) => ({
      sort: "publicationType",
      // reverse: prev.sort === "publicationType" ? !prev.reverse : false,
      reverse: prev.sort === "publicationType" ? prev.reverse : false,
    }));
    dispatch(addArrayAction([]));
    setStoredData([]);
    dispatch(addPageAction(null));
    sessionStorage?.removeItem("savedPosition");
    sessionStorage?.removeItem("savedPage");
  };

  const bookmarksSort = () => {
    setSortField("bookmarks");
    setSortBy((prev) => ({
      sort: "bookmarks",
      reverse: prev.sort === "bookmarks" ? prev.reverse : false,
    }));
    dispatch(addArrayAction([]));
    setStoredData([]);
    dispatch(addPageAction(null));
    sessionStorage?.removeItem("savedPosition");
    sessionStorage?.removeItem("savedPage");
  };

  const argsForSavedFieldsField = {
    fields: [
      {
        name: "SAVED_FIELD",
        type: "select",
        className: "register-login-text-field overview-field",
        required: false,
        classnameofgroup: "register-login-text-field-group overview-group",
        placeholder: t("noneSelected"),
        options: filters,
        defaultValue: "",
        value: savedFilterSelected,
        displayProperty: "FILTER_NAME",
        valueProperty: "FILTER_SEARCH_VALUE",
        onChange: (value) => {
          let startToDate = new Date(),
            startFromDate = new Date();

          startFromDate.setDate(startFromDate.getDate() - 90);

          resetParams();

          setSavedFilterSelected(value);

          setTimeout(function () {
            if (value) applyFilter(value);
            else {
              preparationOfDataBeforeOperation(
                "applyFilter",
                "",
                "",
                "",
                "",
                "",
                "",
                startFromDate,
                startToDate
              );

              setChangeFieldsInFormRadioButtons(8);
            }
          });
        },
      },
    ],
    classNameReactFormal: "register-login-react-formal",
    classNameForm: "register-login-react-form",
  };

  const dateRangeIsDisabled = () => {
    if (multiFilterRadioButtonsValue === "custom") {
      return false;
    }
    return true;
  };

  const argsForFieltersFields = {
    fields: [
      {
        name: "FREE_TEXT",
        type: "text-with-search",
        className: "register-login-react-text-field overview-fieldset-field",
        required: false,
        classnameofgroup:
          "register-login-text-field-group overview-fieldset-group",
        placeholder: t("egDeutcheBank"),
        label: t("searchByKeyword"),
        onChangeText: (value) => {
          setFreeText(value);
          if (!value) preparationOfDataBeforeOperation("clearTextField");
        },
        onSearch: () => preparationOfDataBeforeOperation("getRegulatoryStream"),
        value: freeText,
      },
      {
        name: "PUBLICATION_TYPE",
        type: "multi-select",
        className: "register-login-text-field overview-fieldset-field",
        required: false,
        disabled: false,
        classnameofgroup:
          "register-login-text-field-group overview-fieldset-group",
        options: publicationTypesDataSet,
        selectedOptions: publicationTypes,
        displayProperty: "description",
        valueProperty: "value",
        label: t("publicationType"),
        placeholder: t("egPressRelease"),
        onMultiSelectOptionChanged: (value, description) => {
          let found = publicationTypes.find((el) => {
            return el.value === value;
          });

          if (!found) {
            setPublicationTypes((publicationTypes) => [
              ...publicationTypes,
              {
                description: description,
                value: value,
              },
            ]);
          }
        },
        onMultiSelectOptionRemoved: (value) => {
          setPublicationTypes(
            publicationTypes.filter((o) => o.value !== value)
          );

          setOptionRemoved(true);
          preparationOfDataBeforeOperation("getRegulatoryStream");
        },
      },
      {
        name: "PUBLICATION_TYPE",
        type: "multi-select",
        className: "register-login-text-field overview-fieldset-field",
        required: false,
        disabled: false,
        classnameofgroup:
          "register-login-text-field-group overview-fieldset-group",
        options: countriesDataSet,
        selectedOptions: countries,
        displayProperty: "description",
        valueProperty: "value",
        label: t("country"),
        placeholder: t("egGermany"),
        onMultiSelectOptionChanged: (value, description) => {
          let found = countries.find((el) => {
            return el.value === value;
          });

          if (!found) {
            setCountries((countries) => [
              ...countries,
              {
                description: description,
                value: value,
              },
            ]);
          }
        },
        onMultiSelectOptionRemoved: (value) => {
          setCountries(countries.filter((o) => o.value !== value));

          setOptionRemoved(true);
          preparationOfDataBeforeOperation("getRegulatoryStream");
        },
      },
      {
        name: "PUBLISHER_TYPE",
        type: "multi-select",
        className: "register-login-text-field overview-fieldset-field",
        required: false,
        disabled: false,
        classnameofgroup:
          "register-login-text-field-group overview-fieldset-group",
        options: publisherTypesDataSet,
        selectedOptions: publisherTypes,
        displayProperty: "description",
        valueProperty: "value",
        label: t("publisherType"),
        placeholder: t("egBank"),
        onMultiSelectOptionChanged: (value, description) => {
          let found = publisherTypes.find((el) => {
            return el.value === value;
          });

          if (!found) {
            setPublisherTypes((publisherTypes) => [
              ...publisherTypes,
              {
                description: description,
                value: value,
              },
            ]);
          }
        },
        onMultiSelectOptionRemoved: (value) => {
          setPublisherTypes(publisherTypes.filter((o) => o.value !== value));
          setOptionRemoved(true);
          preparationOfDataBeforeOperation("getRegulatoryStream");
        },
      },
      {
        name: "MULTI_FILTER_RADIO_BUTTONS",
        type: "multi-radiobuttons",
        className: "register-login-text-field overview-fieldset-field",
        required: false,
        classnameofgroup:
          "register-login-text-field-group overview-fieldset-group",
        label: t("date"),
        data: [
          {
            description: t("past7Days"),
            value: "today - 7",
          },
          {
            description: t("past30Days"),
            value: "today - 30",
          },
          {
            description: t("past60Days"),
            value: "today - 60",
          },
          {
            description: t("past90Days"),
            value: "today - 90",
          },
          { description: t("customDateRange"), value: "custom" },
        ],
        displayProperty: "description",
        valueProperty: "value",
        value: multiFilterRadioButtonsValue,
        defaultChecked: multiFilterRadioButtonsValue,
        onRadioButtonChange: (value) => {
          if (value === "today - 7") {
            dateSetter(setFromDate, setToDate, 7);
            dispatch(addArrayAction([]));
            setStoredData([]);
            dispatch(addPageAction(null));
          }

          if (value === "today - 30") {
            dateSetter(setFromDate, setToDate, 30);
            dispatch(addArrayAction([]));
            setStoredData([]);
            dispatch(addPageAction(null));
          }

          if (value === "today - 60") {
            dateSetter(setFromDate, setToDate, 60);
            dispatch(addArrayAction([]));
            setStoredData([]);
            dispatch(addPageAction(null));
          }

          if (value === "today - 90") {
            dateSetter(setFromDate, setToDate, 90);
            dispatch(addArrayAction([]));
            setStoredData([]);
            dispatch(addPageAction(null));
          }
          setMultiFilterRadioButtonsValue(value);
          sessionStorage.removeItem("savedPosition");
          innerScrollRef.current.scrollTo(0, 0);
          dispatch(addArrayAction([]));
          setStoredData([]);
          dispatch(addPageAction(null));
          preparationOfDataBeforeOperation("getRegulatoryStream");
        },
      },
      {
        type: "date",
        name: "FILTER_DATES",
        className: "register-login-text-field overview-fieldset-field",
        classnameofgroup:
          "register-login-text-field-group overview-fieldset-group",
        options: [
          {
            key: "filter-from-date",
            className: "single-filter-date-field form-control left-filter-date",
            placeholder: t("startDate"),
            name: "FROM_FILTER_DATE",
            format: "YYYY/MM/DD",
            type: "date",
            disabled: dateRangeIsDisabled(),
            value: formatDate(fromDate),
            onChangeDate: (value) => {
              setFromDate(new Date(value));
              sessionStorage.setItem("fromDate", value);
            },
          },
          {
            key: "filter-end-date",
            className: "single-filter-date-field form-control",
            placeholder: t("endDate"),
            name: "TO_FILTER_DATE",
            format: "YYYY/MM/DD",
            type: "date",
            disabled: dateRangeIsDisabled(),
            value: formatDate(toDate),
            onChangeDate: (value) => {
              setToDate(new Date(value));
              sessionStorage.setItem("toDate", formatDate(value));
            },
          },
        ],
      },
    ],
    onSubmit: () => {
      preparationOfDataBeforeOperation("getRegulatoryStream");
      sessionStorage.removeItem("savedPosition");
      innerScrollRef.current.scrollTo(0, 0);
    },
    onChange: () => {
      preparationOfDataBeforeOperation("getRegulatoryStream");
    },
    classNameReactFormal: "register-login-react-formal",
    classNameForm: "register-login-react-form",
    typeOfSubmit: "onChange",
    findFormErrors: (form) => {
      const {
        TO_FILTER_DATE,
        FROM_FILTER_DATE,
        MULTI_FILTER_RADIO_BUTTONS,
        FREE_TEXT,
      } = form;
      const newErrors = {};

      let fromDateReplacement = new Date(
          FROM_FILTER_DATE ? FROM_FILTER_DATE : formatDate(fromDate)
        ),
        toDateReplacement = new Date(
          TO_FILTER_DATE ? TO_FILTER_DATE : formatDate(toDate)
        );

      if (
        (!TO_FILTER_DATE || TO_FILTER_DATE === "") &&
        MULTI_FILTER_RADIO_BUTTONS === "unchanged" &&
        !formatDate(toDate)
      )
        newErrors.FILTER_DATES = "End date is mandatory field";
      else if (
        (!FROM_FILTER_DATE || FROM_FILTER_DATE === "") &&
        MULTI_FILTER_RADIO_BUTTONS === "unchanged" &&
        !formatDate(fromDate)
      )
        newErrors.FILTER_DATES = "Start date is mandatory field";
      else if (fromDateReplacement > toDateReplacement)
        newErrors.FILTER_DATES = "Start date must be earlier then end date";
      else if (MULTI_FILTER_RADIO_BUTTONS === "unchanged") {
        setFromDate(fromDateReplacement);
        setToDate(toDateReplacement);
      }

      if (freeText === FREE_TEXT) {
        if (FREE_TEXT && FREE_TEXT.length > 32)
          newErrors.FREE_TEXT = "Keyword can't be longer then 32 charachteres";
        else setFreeText(FREE_TEXT);
      }

      return newErrors;
    },
  };

  // const sortedRegulatoryStream = useMemo(() => {
  //   if (sortBy.sort === "publisher") {
  //     return JSON.parse(JSON.stringify(regulatoryStream)).sort((a, b) => {
  //       if (a.source_name < b.source_name) {
  //         return sortBy.reverse ? 1 : -1;
  //       }
  //       if (a.source_name > b.source_name) {
  //         return sortBy.reverse ? -1 : 1;
  //       }
  //       return 0;
  //     });
  //   }
  //   if (sortBy.sort === "publicationDate") {
  //     return JSON.parse(JSON.stringify(regulatoryStream)).sort((a, b) =>
  //       sortBy.reverse
  //         ? new Date(a.news_date) - new Date(b.news_date)
  //         : new Date(b.news_date) - new Date(a.news_date)
  //     );
  //   }
  //   if (sortBy.sort === "publicationType") {
  //     return JSON.parse(JSON.stringify(regulatoryStream)).sort((a, b) => {
  //       if (a.news_type < b.news_type) {
  //         return sortBy.reverse ? 1 : -1;
  //       }
  //       if (a.news_type > b.news_type) {
  //         return sortBy.reverse ? -1 : 1;
  //       }
  //       return 0;
  //     });
  //   }
  //   return sortBy.reverse
  //     ? JSON.parse(JSON.stringify(regulatoryStream)).reverse()
  //     : regulatoryStream;
  // }, [regulatoryStream, sortBy.reverse, sortBy.sort]);

  // const summarizedTopicsPerUnits = useMemo(() => {
  //   let totalValue = 0;

  //   Object.entries(hotTopics).map(([, topic]) => {
  //     Object.entries(hotBusinessUnits).map(([, unit]) => {
  //       if (topic && unit) totalValue += topic * unit;
  //     });
  //   });

  //   return totalValue || 1;
  // }, [hotBusinessUnits, hotTopics]);

  // const handleImgError = useCallback((e) => {
  //   e.target.onerror = null;
  //   e.target.src = `${IMAGE_BASE}topic.jpg`;
  // }, []);

  useEffect(() => {
    if (filterFailureMessage) {
      setFailureMessage(filterFailureMessage);
    }

    if (filterSuccessMessage) {
      setSuccessMessage(filterSuccessMessage);
    }

    if (changeRadioButtonValue) {
      setChangeFieldsInFormRadioButtons(changeRadioButtonValue);
      setChangeRadioButtonValue(0);
    }

    if (optionRemoved) {
      preparationOfDataBeforeOperation("getRegulatoryStream");
      setOptionRemoved(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    filterFailureMessage,
    filterSuccessMessage,
    setFailureMessage,
    setSuccessMessage,
    filterMessagesRestarted,
    changeRadioButtonValue,
    setChangeRadioButtonValue,
  ]);

  useEffect(() => {
    if (filterFailureMessage) {
      setFailureMessage(filterFailureMessage);
    }

    if (filterSuccessMessage) {
      setSuccessMessage(filterSuccessMessage);
    }
  }, [
    filterFailureMessage,
    filterSuccessMessage,
    setFailureMessage,
    setSuccessMessage,
    filterMessagesRestarted,
  ]);

  const [countriesList, setCountriesList] = useState(null);
  const [fromDateFormatted, setFromDateFormatted] = useState(null);
  const [toDateFormatted, setToDateFormatted] = useState(null);
  const [publicationTypesValue, setPublicationTypesValue] = useState(null);
  const [publisherTypesValue, setPublisherTypesValue] = useState(null);
  const [loading, isLoading] = useState(false);
  const [newsArr, setNewsArr] = useState([]);
  const [storedData, setStoredData] = useState(null);

  useEffect(() => {
    if (countries && countries.length > 0) {
      const countriesValues = countries.map((item) => item.value);
      const countriesList = countriesValues.join(";") + ";";
      setCountriesList(countriesList);
    } else {
      setCountriesList("");
    }
  }, [countries]);

  // useEffect(() => {
  //   const fromDateIso = dateformat(fromDate, "isoDateTime");
  //   const fromDateFormatted = fromDateIso.split("T")[0];
  //   setFromDateFormatted(fromDateFormatted);

  //   const toDateIso = dateformat(toDate, "isoDateTime");
  //   const toDateFormatted = toDateIso.split("T")[0];
  //   setToDateFormatted(toDateFormatted);
  // }, [fromDate, toDate]);

  let fromDateStoredVal = sessionStorage.getItem("fromDate");
  let toDateStoredVal = sessionStorage.getItem("toDate");

  useEffect(() => {
    if (fromDateStoredVal) {
      setFromDateFormatted(fromDateStoredVal);
    }
    if (toDateStoredVal) {
      setToDateFormatted(toDateStoredVal);
    }
  }, [fromDateStoredVal, toDateStoredVal]);

  useEffect(() => {
    if (publicationTypes && publicationTypes.length > 0) {
      let publicationTypesValue =
        publicationTypes.map((item) => item.value).join(";") + ";";
      setPublicationTypesValue(publicationTypesValue);
    } else {
      setPublicationTypesValue("");
    }
  }, [publicationTypes]);

  useEffect(() => {
    if (publisherTypes && publisherTypes.length > 0) {
      let publisherTypesValue =
        publisherTypes.map((item) => item.value).join(";") + ";";
      setPublisherTypesValue(publisherTypesValue);
    } else {
      setPublisherTypesValue("");
    }
  }, [publisherTypes]);

  useEffect(() => {
    setSortingFieldValue(getSortType(sortBy.sort));
    sessionStorage.setItem("sortBy", JSON.stringify(sortBy));
    sessionStorage.setItem("sortField", getSortType(sortBy.sort));
    setSortField(getSortType(sortBy.sort));
  }, [setSortField, sortBy]);

  const handleSaveScrollPosition = (index) => {
    const savedPosition = innerScrollRef.current.scrollTop;
    sessionStorage.setItem("savedPosition", savedPosition);
    sessionStorage.setItem("savedPosition", savedPosition);
    let trialPage = index / 10;
    let finalPage = trialPage + 1;
    let trunc = Math.trunc(finalPage);

    dispatch(addArrayAction(newsArr));
    dispatch(addPageAction(trunc));
    dispatch(regulatoryStreamsAreClean());
  };

  const handleSaveScrollPositionAndDelete = (index) => {
    const savedPosition = innerScrollRef.current.scrollTop;
    sessionStorage.setItem("savedPosition", savedPosition);

    let trialPage = index / 10;
    let finalPage = trialPage + 1;
    let trunc = Math.trunc(finalPage);
    sessionStorage.setItem("savedPage", trunc);

    dispatch(addPageAction(trunc));
  };

  useEffect(() => {
    isLoading(true);
    setSortingFieldValue(JSON.parse(sessionStorage.getItem("sortBy")));
    let getSortFiled = sessionStorage.getItem("sortField");
    setSortField(getSortFiled ? getSortFiled : "");
    isLoading(false);
  }, [setSortField]);

  useEffect(() => {
    isLoading(true);
    const getPosition = sessionStorage.getItem("savedPosition");
    setTimeout(() => {
      isLoading(true);
      if (innerScrollRef.current) {
        innerScrollRef.current.scrollTo(0, getPosition);
        isLoading(false);
      }
    }, 3500);
    isLoading(false);
  }, []);

  useEffect(() => {
    if (getPageFromStore !== 1) {
      setPage(getPageFromStore);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // eslint-disable-next-line react-redux/useSelector-prefer-selectors
  const getPageFromStore = useSelector((state) => state.addPageReducer);

  // eslint-disable-next-line react-redux/useSelector-prefer-selectors
  const dataFromStore = useSelector((state) => {
    return state.newsListReducer;
  });

  useEffect(() => {
    isLoading(true);
    if (dataFromStore.length !== 0 || dataFromStore !== null) {
      setStoredData(dataFromStore);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    isLoading(true);
    // eslint-disable-next-line prettier/prettier
    if (
      storedData === null ||
      storedData.length === 0 ||
      dataFromStore.length === 0
    ) {
      const uniqueArr = regulatoryStream.reduce((acc, el) => {
        if (acc.findIndex((obj) => el.id === obj.id)) {
          return acc;
        }

        acc.push(el);
        return acc;
      }, []);

      setNewsArr(uniqueArr);
    } else {
      setNewsArr(storedData);
    }
    isLoading(false);
  }, [dataFromStore, regulatoryStream, storedData]);

  useEffect(() => {
    const uniqueArr = regulatoryStream.filter(
      (obj, index) =>
        regulatoryStream.findIndex((item) => item.id === obj.id) === index
    );

    if (storedData !== null || storedData.length !== 0) {
      if (uniqueArr.length > dataFromStore.length) {
        setNewsArr(uniqueArr);
      }
    }
  }, [dataFromStore, dataFromStore.length, regulatoryStream, storedData]);

  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        window.location.reload();
      }
    };
    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  const handleAskModal = () => {
    setAskAQuestionModal(true);
  };

  const askAQuestionFields = {
    fields: [
      {
        name: "YOUR_QUESTION",
        type: "textarea",
        className: "ask-question-textarea-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("yourQuestion"),
        placeholder: t("yourQuestionPlaceholder"),
      },
      {
        name: "THE_ANSWER",
        type: "textarea",
        className: "answer-textarea-field",
        required: true,
        classnameofgroup: "add-news-full-width-fields-group",
        label: t("theAnswer"),
      },
    ],
    findFormErrors: (form) => {
      const { YOUR_QUESTION } = form;

      const newsErrors = {};
      if (!YOUR_QUESTION || YOUR_QUESTION === "") {
        newsErrors.YOUR_QUESTION = "Your Question is mandatory field";
      }
      return newsErrors;
    },
  };

  return (
    <>
      <Container className="overview-small-screen-container" expand="lg">
        <Button
          className="overview-sm-filters-button"
          type="button"
          onClick={() => setRaiseFiltersModal(true)}
        >
          {t("filters")}
        </Button>
        <Card
          className={
            showGraph
              ? "overview-second-col-first-row-first-col-first-card no-border overview-responsive-card aggregation-graph-responsive"
              : "overview-second-col-first-row-first-col-first-card no-border overview-responsive-card height-auto"
          }
        >
          <Card.Body>
            <span
              className="first-card-first-col-title fs-16 cursor-pointer"
              onClick={() => {
                if (!showGraph) setShowGraph(true);
                else setShowGraph(false);
              }}
            >
              {t("publications")}
              <img
                width={24}
                height={24}
                className={
                  !showGraph
                    ? "arrow-icon arrow-icon-down cursor-pointer"
                    : "display-none"
                }
                src={iconsSortUp}
                onClick={() => setShowGraph(true)}
              />
              <img
                width={24}
                height={24}
                className={
                  !showGraph
                    ? "display-none"
                    : "arrow-icon arrow-icon-up cursor-pointer"
                }
                onClick={() => setShowGraph(false)}
                src={iconsSortUp}
              />
            </span>
            <span
              className={
                showGraph ? "first-card-first-col-total" : "display-none"
              }
            >
              <span className="first-card-first-col-footer-total fs-12">
                {t("total")}
              </span>
              <span className="first-card-first-col-footer-total-value fs-30">
                {graphAggregationsTotalAmount}
              </span>
              {graphAggregationsDetailsFormatted && (
                <Chart
                  chartType="LineChart"
                  data={
                    graphAggregationsDetailsFormatted.length &&
                    graphAggregationsDetailsFormatted
                  }
                  className={"line-chart-graph-aggregation"}
                  height={350}
                  options={{
                    series: {
                      0: { color: "#00C853" },
                    },
                    legend: {
                      position: "bottom",
                    },
                  }}
                />
              )}
            </span>
          </Card.Body>
        </Card>
        <Card
          className={
            showTop5Publishers
              ? "overview-second-col-first-row-first-col-second-card no-border overview-responsive-card top5-publishers-responsive-card"
              : "overview-second-col-first-row-first-col-second-card no-border overview-responsive-card top5-publishers-responsive-card height-auto"
          }
        >
          <Card.Body>
            <span
              className="first-card-first-col-title fs-16 cursor-pointer"
              onClick={() => {
                if (!showTop5Publishers) setShowTop5Publishers(true);
                else setShowTop5Publishers(false);
              }}
            >
              {t("top5Publishers")}
              <img
                width={24}
                height={24}
                className={
                  !showTop5Publishers
                    ? "arrow-icon arrow-icon-down cursor-pointer"
                    : "display-none"
                }
                src={iconsSortUp}
                onClick={() => setShowTop5Publishers(true)}
              />
              <img
                width={24}
                height={24}
                className={
                  !showTop5Publishers
                    ? "display-none"
                    : "arrow-icon arrow-icon-up cursor-pointer"
                }
                onClick={() => setShowTop5Publishers(false)}
                src={iconsSortUp}
              />
            </span>
            <span
              className={
                showTop5Publishers
                  ? "first-card-first-col-footer"
                  : "display-none"
              }
            >
              {Object.keys(top5Publishers).map((publisher, index) => {
                return (
                  <span
                    key={publisher + index}
                    className="top-5-publisher no-border"
                  >
                    <span className="top-5-publisher-name fs-12">
                      {publisher}
                    </span>
                    <span className="top-5-publisher-value fs-30">
                      {top5Publishers[publisher]}
                    </span>
                  </span>
                );
              })}
            </span>
          </Card.Body>
        </Card>
        <Card
          className={
            showTop5Countries
              ? "overview-second-col-first-row-first-col-second-card no-border overview-responsive-card top5-publishers-responsive-card"
              : "overview-second-col-first-row-first-col-second-card no-border overview-responsive-card top5-publishers-responsive-card height-auto"
          }
        >
          <Card.Body>
            <span
              className="first-card-first-col-title fs-16 cursor-pointer"
              onClick={() => {
                if (!showTop5Countries) setShowTop5Countries(true);
                else setShowTop5Countries(false);
              }}
            >
              {t("top5Countries")}

              <img
                width={24}
                height={24}
                className={
                  !showTop5Countries
                    ? "arrow-icon arrow-icon-down cursor-pointer"
                    : "display-none"
                }
                src={iconsSortUp}
                onClick={() => setShowTop5Countries(true)}
              />
              <img
                width={24}
                height={24}
                className={
                  !showTop5Countries
                    ? "display-none"
                    : "arrow-icon arrow-icon-up cursor-pointer"
                }
                onClick={() => setShowTop5Countries(false)}
                src={iconsSortUp}
              />
            </span>
            <span
              className={
                showTop5Countries
                  ? "first-card-first-col-footer third-card-second-col-top-counties"
                  : "display-none"
              }
            >
              {Object.entries(top5Countries)
                .sort((a, b) => b[1] - a[1])
                .map(([country, value]) => {
                  return (
                    <p
                      className="info-with-icon-and-text fs-14"
                      key={country + value}
                    >
                      <img
                        width={16}
                        height={16}
                        src={EARTH_ICON}
                        className="left-options-icon"
                      />
                      {country}: {value}
                    </p>
                  );
                })}
            </span>
          </Card.Body>
        </Card>
        {/* <Card className="overview-second-col-first-row-first-col-fourth-card no-border">
          <Card.Body>
            <div className="overview-fourth-card-left">
              <div>
                <span className="first-card-first-col-title fs-16">
                  {t("hotTopics")}
                </span>
                <div className="overview-fourth-card-left-topics">
                  {Object.entries(hotTopics).map(([topic, value]) => (
                    <p
                      className="info-with-icon-and-text fs-12"
                      key={topic + value}
                    >
                      <img
                        width={14}
                        height={14}
                        src={makeImageSrcByName(topic)}
                        onError={handleImgError}
                        className="left-options-icon"
                      />
                      {topic}
                    </p>
                  ))}
                </div>
              </div>
              <div>
                <span className="first-card-first-col-title fs-16">
                  {t("hotBusinessUnits")}
                </span>
                <div className="overview-fourth-card-left-topics">
                  {Object.entries(hotBusinessUnits).map(([topic, value]) => (
                    <p
                      className="info-with-icon-and-text fs-12"
                      key={topic + value}
                    >
                      <img
                        width={14}
                        height={14}
                        src={makeImageSrcByName(topic)}
                        onError={handleImgError}
                        className="left-options-icon"
                      />
                      {topic}
                    </p>
                  ))}
                </div>
              </div>
            </div>
            <div className="overview-fourth-card-right">
              <span className="first-card-first-col-title overview-fourth-card-right-title fs-16">
                {t("hotTopicsPerBusinessUnit")}
              </span>
              <div className="overview-fourth-card-right-graph">
                <div className="overview-fourth-card-right-graph-row-text">
                  {topicsPerBusinessUnits.topics.map((topic) => (
                    <div className="graph-row-text-vertical fs-12" key={topic}>
                      <div>{topic}</div>
                    </div>
                  ))}
                </div>
                {topicsPerBusinessUnits.units.map((unit) => {
                  return (
                    <div
                      className="overview-fourth-card-right-graph-row"
                      key={unit}
                    >
                      <div className="graph-row-text-horizontal fs-12">
                        {unit}
                      </div>
                      {topicsPerBusinessUnits.topics.map((topic) => {
                        const cellColor = processGraphCellValue(
                          hotTopics[topic],
                          hotBusinessUnits[unit],
                          summarizedTopicsPerUnits
                        );

                        return (
                          <div
                            key={topic}
                            className={`overview-fourth-card-right-graph-col graph-${cellColor}`}
                          />
                        );
                      })}
                    </div>
                  );
                })}
                <div className="overview-fourth-card-right-graph-footer">
                  <div className="overview-fourth-card-right-graph-footer-col graph-hot" />
                  <p className="overview-fourth-card-right-graph-footer-text fs-12">
                    Hot
                  </p>
                  <div className="overview-fourth-card-right-graph-footer-col graph-warm" />
                  <p className="overview-fourth-card-right-graph-footer-text fs-12">
                    Warm
                  </p>
                  <div className="overview-fourth-card-right-graph-footer-col graph-tepid" />
                  <p className="overview-fourth-card-right-graph-footer-text fs-12">
                    Tepid
                  </p>
                </div>
              </div>
            </div>
          </Card.Body>
        </Card> */}
        <Col className="overview-second-col-first-row-second-col">
          <div className="overview-second-col-first-row-second-col-header">
            <span className="first-card-first-col-title fs-16">
              {t("newslist")}
            </span>
            <div className="btnWrapper">
              <div className="innerBtnWrapper">
                <button
                  style={{ height: "44px", border: "1px solid #5757A3" }}
                  className="overview-second-col-card-btn overview-second-col-first-row-btn"
                  type="button"
                  onClick={handleAskModal}
                >
                  <img
                    width={16}
                    height={16}
                    src={iconsAskAQuestion}
                    className="left-options-icon"
                  />
                  <p
                    className="overview-second-col-card-btn-text fs-16"
                    style={{ color: "#5757A3" }}
                  >
                    {t("askaQuestion")}
                  </p>
                </button>

                <button
                  className="overview-second-col-card-btn overview-second-col-first-row-btn"
                  type="button"
                  onClick={() => setAddNewsModal(true)}
                  disabled={
                    !(
                      userRights.USER_RIGHT?.toLowerCase().includes(
                        "read_write_delete_new"
                      ) ||
                      userRights.USER_RIGHT?.toLowerCase().includes("partner")
                    )
                  }
                >
                  <img
                    width={32}
                    height={32}
                    src={iconsAddToList}
                    className="left-options-icon"
                  />
                  <p className="overview-second-col-card-btn-text fs-16">
                    {t("addANews")}
                  </p>
                </button>
              </div>

              <Dropdown
                variant="secondary"
                autoclose="false"
                className="overview-second-col-first-row-second-col-sort"
              >
                <Dropdown.Toggle className="overview-second-col-first-row-second-col-sort-btn fs-16">
                  {t(sortBy.sort)}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onSelect={() => revelanceSort()}>
                    {t("relevance")}
                  </Dropdown.Item>
                  <Dropdown.Item onSelect={() => newsDateSort()}>
                    {t("publicationDate")}
                  </Dropdown.Item>
                  <Dropdown.Item onSelect={() => newsTypeSort()}>
                    {t("publicationType")}
                  </Dropdown.Item>
                  <Dropdown.Item onSelect={() => bookmarksSort()}>
                    {t("bookmarks")}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          {regulatoryStreamAreLoading && !regulatoryStream?.length && loading && (
            <div className="overview-second-col-first-row-second-col-loader">
              <Spinner animation="border" className="loader">
                <span className="sr-only">{t("loading")}</span>
              </Spinner>
            </div>
          )}
          <div
            className="overview-second-col-first-row-second-col-body"
            id="innerScroll"
            ref={innerScrollRef}
          >
            {regulatoryStream?.length && (
              <InfiniteScroll
                loadMore={() => {
                  if (
                    !regulatoryStreamLoadedWithError &&
                    !regulatoryStreamPaginationError &&
                    !regulatoryStreamAreLoading &&
                    regulatoryStream?.length
                  )
                    handlePagination();
                }}
                hasMore={true}
                useWindow={false}
              >
                {/* {sortedRegulatoryStream?.map( */}
                {/* {dataFromStore?.map( */}
                {newsArr?.map(
                  (
                    {
                      id,
                      bookmark,
                      news_link,
                      news_summary,
                      news_date,
                      news_topic,
                      news_type,
                      news_title,
                      source_name,
                      news_label,
                    },
                    index
                  ) => (
                    <Card
                      className="overview-second-col-first-row-second-col-card no-border"
                      key={id + index}
                    >
                      <Card.Header className="overview-second-col-card-header no-border">
                        <div
                          className="overview-second-col-card-header-star"
                          onClick={() => {
                            setPage(1);
                            if (loggedIn) {
                              if (bookmark) {
                                unbookmarkDocument(
                                  userToken,
                                  news_title,
                                  singleTopic.TOPIC_ID || "",
                                  id,
                                  freeText,
                                  singleTopic.TOPIC_SEARCHTAGS,
                                  publicationTypesValue,
                                  fromDateFormatted,
                                  toDateFormatted,
                                  publisherTypesValue,
                                  countriesList,
                                  sortingFieldValue
                                );
                              } else {
                                bookmarkDocument(
                                  userToken,
                                  news_title,
                                  singleTopic.TOPIC_ID || "",
                                  id,
                                  freeText,
                                  singleTopic.TOPIC_SEARCHTAGS,
                                  publicationTypesValue,
                                  fromDateFormatted,
                                  toDateFormatted,
                                  publisherTypesValue,
                                  countriesList,
                                  sortingFieldValue
                                );
                              }
                            }
                          }}
                        >
                          <StarBookmark value={bookmark} />
                        </div>
                        <div>
                          <a
                            className="overview-second-col-card-title"
                            href={news_link}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {news_title}
                          </a>
                          <br />
                          <span className="span-date-source">
                            {news_date
                              ? formatDate(new Date(news_date), "dd.mm.yyyy")
                              : ""}{" "}
                            | {source_name || "-"}{" "}
                            <p
                              style={{
                                background: `${getColorByCategory(news_type)}`,
                              }}
                              className="overview-second-col-card-text overview-second-col-card-type fs-12"
                            >
                              {news_type || "-"}
                            </p>
                          </span>
                        </div>

                        <div className="overview-second-col-card-btns-res">
                          <button
                            className="overview-second-col-card-btn"
                            type="button"
                            disabled={
                              !(
                                userRights.USER_RIGHT?.toLowerCase().includes(
                                  "read_write_delete_new"
                                ) ||
                                userRights.USER_RIGHT?.toLowerCase().includes(
                                  "partner"
                                )
                              )
                            }
                            onClick={() => setEditNewsModal(id)}
                          >
                            <img
                              width={24}
                              height={24}
                              src={iconsEdit}
                              className="left-options-icon"
                            />
                            <p className="overview-second-col-card-btn-text fs-14">
                              {t("edit")}
                            </p>
                          </button>
                          <button
                            className="overview-second-col-card-btn"
                            type="button"
                            onClick={() => {
                              showDeleteNewsModal(id);
                              handleSaveScrollPositionAndDelete(index);
                            }}
                            disabled={
                              !(
                                userRights.USER_RIGHT?.toLowerCase().includes(
                                  "read_write_delete"
                                ) ||
                                userRights.USER_RIGHT?.toLowerCase().includes(
                                  "read_write_delete_new"
                                ) ||
                                userRights.USER_RIGHT?.toLowerCase().includes(
                                  "partner"
                                )
                              )
                            }
                          >
                            <img
                              width={24}
                              height={24}
                              src={iconsDelete}
                              className="left-options-icon"
                            />
                            <p className="overview-second-col-card-btn-text fs-14">
                              {t("delete")}
                            </p>
                          </button>
                          <button
                            className="overview-second-col-card-btn"
                            type="button"
                            onClick={() => {
                              handleSaveScrollPosition(index);
                              history.push(
                                GET_DOCUMENT_BY_ID_AWAITING_ID + id,
                                {
                                  from: "topic",
                                }
                              );
                              localStorage.setItem(
                                "singleDocumentTitleName",
                                news_title
                              );
                            }}
                          >
                            <img
                              width={24}
                              height={24}
                              src={iconsExternalLink}
                              className="left-options-icon"
                            />
                            <p className="overview-second-col-card-btn-text fs-14">
                              {t("assess")}
                            </p>
                          </button>
                          <Dropdown flip={false}>
                            <Dropdown.Toggle
                              id="private-header-workspace-dropdown-toggle"
                              className="dropdown-toggle-icon-hidden"
                            >
                              <img src={iconThreeDotsHorizontal} />
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                              className="header-dropdown"
                              align="right"
                            >
                              <Dropdown.Item
                                onClick={() => {
                                  if (loggedIn) {
                                    setAddToListDialogIsShown(true);
                                    setSelectedNew({ id, news_title });
                                  }
                                }}
                              >
                                <span
                                  className={`${
                                    loggedIn
                                      ? "document-header-right-option cursor-pointer"
                                      : "document-header-right-option document-header-right-option-forbidden cursor-not-allowed"
                                  } fs-14`}
                                >
                                  <img
                                    width={24}
                                    height={24}
                                    className="right-options-icon"
                                    src={iconsAddToList}
                                  />
                                  <span className="document-header-right-option-label">
                                    {t("addToList")}
                                  </span>
                                </span>
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  if (loggedIn) {
                                    setAskAQuestionModal(true);
                                    sessionStorage.setItem(
                                      "separateNewsAsk",
                                      true
                                    );
                                    sessionStorage.setItem("reference_id", id);
                                    localStorage.setItem(
                                      "singleDocumentTitleName",
                                      news_title
                                    );
                                  }
                                }}
                              >
                                <span
                                  className={`${
                                    loggedIn
                                      ? "document-header-right-option cursor-pointer"
                                      : "document-header-right-option document-header-right-option-forbidden cursor-not-allowed"
                                  } fs-14`}
                                >
                                  <img
                                    width={16}
                                    height={16}
                                    src={iconsAskAQuestion}
                                    className="right-options-icon"
                                    style={{ margin: "0 5px" }}
                                  />
                                  <span className="document-header-right-option-label">
                                    {t("askaQuestion")}
                                  </span>
                                </span>
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      </Card.Header>
                      {news_summary.length > 1 && (
                        <div className="container-btn-show-more-less">
                          <button
                            className="btn-show-more-less"
                            onClick={() => {
                              toggleVisibility(id);
                            }}
                          >
                            {itemVisibility[id] ? "Collapse" : "Show More"}
                          </button>
                        </div>
                      )}
                      <div
                        className={`${
                          !itemVisibility[id] ? "card-hidden" : ""
                        }`}
                      >
                        <Card.Body className="overview-second-col-card-body">
                          <p className="overview-second-col-card-subtitle  fs-14">
                            {t("summary")}
                          </p>
                          <p
                            className="overview-second-col-card-text summary fs-14"
                            dangerouslySetInnerHTML={{
                              __html: sanitizer(
                                itemVisibility[id]
                                  ? news_summary
                                  : news_summary.slice(0, 900),
                                {
                                  ADD_TAGS: ["img", "a"],
                                  ADD_ATTR: ["target"],
                                  FORBID_TAGS: ["script"],
                                  // eslint-disable-next-line no-useless-escape
                                  ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
                                }
                              ),
                            }}
                          />
                        </Card.Body>
                        <Card.Footer className="overview-second-col-card-footer">
                          <Row>
                            <Col>
                              <p className="overview-second-col-card-subtitle fs-14">
                                {t("topics")}
                              </p>
                              {news_topic
                                ?.filter((topic) => topic?.comment === "TOPIC")
                                .map(({ description }) => (
                                  <div
                                    key={description}
                                    className="overview-second-col-card-footer-topics"
                                  >
                                    <img
                                      width={30}
                                      height={30}
                                      src={makeImageSrcByName(description)}
                                      className="filter-icon"
                                    />
                                    <p className="overview-second-col-card-text fs-12">
                                      {description || "---"}
                                    </p>
                                  </div>
                                ))}
                            </Col>
                            <Col>
                              <p className="overview-second-col-card-subtitle fs-14">
                                {t("affectedBusinessUnits")}
                              </p>
                              {news_topic
                                ?.filter(
                                  (topic) => topic?.comment === "BUSINESS UNIT"
                                )
                                .map(({ description }) => (
                                  <div
                                    key={description}
                                    className="overview-second-col-card-footer-topics"
                                  >
                                    <img
                                      width={30}
                                      height={30}
                                      src={makeImageSrcByName(description)}
                                      className="filter-icon"
                                    />
                                    <p className="overview-second-col-card-text fs-12">
                                      {description || "---"}
                                    </p>
                                  </div>
                                ))}
                            </Col>
                          </Row>
                          {/* FIX CURATED issue 69  */}
                          {news_label === "curated" && (
                            <Row>
                              <Col className="news-card__bottom-label-wrapper">
                                <div className="news-card__bottom-label">
                                  curated
                                </div>
                              </Col>
                            </Row>
                          )}
                        </Card.Footer>
                      </div>
                    </Card>
                  )
                )}
              </InfiniteScroll>
            )}
          </div>
        </Col>
      </Container>
      <CustomModal
        classNameOfModal="reghub-loading-modal"
        isShown={
          filtersAreLoading ||
          filtersTypesAreLoading ||
          (regulatoryStreamAreLoading && !regulatoryStream?.length) ||
          top5PublishersAreLoading ||
          top5CountriesAreLoading ||
          hotTopicsAndBusinessUnitsAreLoading ||
          graphAggregationsAreLoading ||
          !graphAggregationsDetailsFormatted?.length
        }
        content={<Loader />}
        titleOfModal={t("loading")}
        isCentered={true}
        isBackdrop="static"
      />
      <CustomModal
        titleOfModal={t("addToList")}
        positiveButton={t("addToList")}
        negativeButton={t("cancel")}
        positiveAction={() => setSubmitOccurred(true)}
        negativeAction={() => {
          setAddToListDialogIsShown(false);
          setTile(tilesOfTypeLinks.length > 0 ? tilesOfTypeLinks[0] : {});
        }}
        setIsShown={setAddToListDialogIsShown}
        isShown={addToListDialogIsShown}
        classNameOfModal="add-to-list-modal"
        formId="add-new-topic-group-form"
        content={
          <FieldsInForm
            idOfForm="add-to-list-form"
            fields={argsForAddListDialog.fields}
            onSubmit={argsForAddListDialog.onSubmit}
            findFormErrors={argsForAddListDialog.findFormErrors}
            setSubmitOccurred={setSubmitOccurred}
            submitOccurred={submitOccurred}
            classNameForm={argsForAddListDialog.classNameForm}
            onSelectBoxChanged={argsForAddListDialog.onSelectBoxChanged}
          />
        }
        isBackdrop="static"
      />
      <CustomModal
        positiveButton={t("newsSaveBtn")}
        positiveAction={() => {
          setSubmitNewsOccurred(true);
        }}
        titleOfModal={t("askaQuestion")}
        negativeAction={() => {
          setAskAQuestionModal(false);
          dispatch(aIResponseCloseModal());
          // sessionStorage.removeItem("separateNewsAsk");
          // sessionStorage.removeItem("reference_id");
        }}
        isShown={askAQuestionModal}
        setIsShown={setAskAQuestionModal}
        isBackdrop="static"
        isCentered={true}
        classNameOfModal="reghub-modal add-news-modal ask"
        content={
          <FieldsInForm
            idOfForm="ask-a-question-form"
            fields={askAQuestionFields.fields}
            findFormErrors={askAQuestionFields.findFormErrors}
          />
        }
      />
      <CustomModal
        classNameOfModal="reghub-filters-modal"
        isShown={raiseFiltersModal}
        setIsShown={setRaiseFiltersModal}
        titleOfModal={t("filters")}
        positiveButton={t("showResults")}
        positiveAction={() => setRaiseFiltersModal(false)}
        isBackdrop="static"
        content={
          <>
            <span
              className="overview-filter-header-left-title-option fs-14 cursor-pointer"
              onClick={() => {
                resetParams();
                setSavedFilterSelected("");

                let startToDate = new Date(),
                  startFromDate = new Date();

                startFromDate.setDate(startFromDate.getDate() - 90);

                preparationOfDataBeforeOperation(
                  "applyFilter",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  startFromDate,
                  startToDate
                );

                filtersFormRef?.current?.updateRadioButtons(8);
                sessionStorage.removeItem("freeText");
                sessionStorage.removeItem("publisherTypes");
                sessionStorage.removeItem("publicationTypes");
                sessionStorage.removeItem("countries");
              }}
            >
              <img
                width={24}
                height={24}
                src={iconsClearAll}
                className="filter-icon"
              />
              {t("clearAll")}
            </span>
            <div className="overview-filter-saved-filters fs-14">
              <div className="overview-filter-saved-filters-label-manage">
                <span className="overview-filter-saved-filters-label">
                  {t("savedFilters")}
                </span>
                <span
                  className="overview-filter-saved-filters-manage cursor-pointer"
                  onClick={() => setRaiseManageFiltersModal(true)}
                >
                  <img
                    width={24}
                    height={24}
                    src={iconsManage}
                    className="filter-icon"
                  />
                  <span className="overview-filter-saved-filters-manage-label">
                    {t("manage")}
                  </span>
                </span>
              </div>
              <FieldsInForm
                key="saved-field-sets"
                fields={argsForSavedFieldsField.fields}
              />
            </div>
            <div className="overview-filter-filters fs-14">
              <FieldsInForm
                key="fields-of-field-set"
                ref={filtersFormRef}
                fields={argsForFieltersFields.fields}
                onSubmit={argsForFieltersFields.onSubmit}
                onChange={argsForFieltersFields.onChange}
                typeOfSubmit={argsForFieltersFields.typeOfSubmit}
                findFormErrors={argsForFieltersFields.findFormErrors}
                changeFieldsInFormRadioButtons={changeFieldsInFormRadioButtons}
                setChangeFieldsInFormRadioButtons={
                  setChangeFieldsInFormRadioButtons
                }
              />
            </div>
            <div className="overview-filter-card-footer">
              <Button
                className="card-filter-footer-button fs-14"
                type="button"
                onClick={() => setRaiseSaveFilterModal(true)}
              >
                <img
                  width={24}
                  height={24}
                  src={iconsSaveFilterSet}
                  className="filter-icon"
                />
                {t("saveFilterSet")}
              </Button>
            </div>
          </>
        }
      />
      {failureMessage && !regulatoryStreamPaginationError && (
        <AlertMessage
          variant="danger"
          onClose={() => {
            filterMessagesRestarted();
            setFailureMessage("");
          }}
          successHeading={t("failure")}
          mainMessage={failureMessage}
        />
      )}
      {successMessage && (
        <AlertMessage
          variant="success"
          onClose={() => {
            filterMessagesRestarted();
            setSuccessMessage("");
          }}
          successHeading={t("success")}
          mainMessage={successMessage}
        />
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userToken: state.configReducer.userToken,
    loggedIn: state.userReducer.loggedIn,
    singleDocument: state.filterReducer.singleDocument,
    singleTopic: state.topicReducer.singleTopic,
    userRights: state.userReducer.userRights,
    filtersAreLoading: state.filterReducer.filtersAreLoading,
    filtersTypesAreLoading: state.filterReducer.filtersTypesAreLoading,
    regulatoryStreamAreLoading: state.filterReducer.regulatoryStreamAreLoading,
    regulatoryStreamLoadedWithError:
      state.filterReducer.regulatoryStreamLoadedWithError,
    regulatoryStreamPaginationError:
      state.filterReducer.regulatoryStreamPaginationError,
    top5PublishersAreLoading: state.filterReducer.top5PublishersAreLoading,
    top5CountriesAreLoading: state.filterReducer.top5CountriesAreLoading,
    graphAggregationsAreLoading:
      state.filterReducer.graphAggregationsAreLoading,
    hotTopicsAndBusinessUnitsAreLoading:
      state.filterReducer.hotTopicsAndBusinessUnitsAreLoading,
    graphAggregationsTotalAmount:
      state.filterReducer.graphAggregationsTotalAmount,
    top5Publishers: state.filterReducer.top5Publishers,
    top5Countries: state.filterReducer.top5Countries,
    hotTopics: state.filterReducer.hotTopics,
    hotBusinessUnits: state.filterReducer.hotBusinessUnits,
    regulatoryStream: state.filterReducer.regulatoryStream,
    tiles: state.tileReducer.tiles,
    tilesOfTypeLinks: state.tileReducer.tilesOfTypeLinks,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    bookmarkDocument: bindActionCreators(bookmarkDocument, dispatch),
    unbookmarkDocument: bindActionCreators(unbookmarkDocument, dispatch),
    filterMessagesRestarted: bindActionCreators(
      filterMessagesRestarted,
      dispatch
    ),
    getTilesOfTypeLinks: bindActionCreators(getTilesOfTypeLinks, dispatch),
    addLink: bindActionCreators(addLink, dispatch),
    addDocument: bindActionCreators(addDocument, dispatch),
  };
};

OverviewSmallScreenContainer.propTypes = {
  bookmarkDocument: PropTypes.func.isRequired,
  unbookmarkDocument: PropTypes.func.isRequired,
  userToken: PropTypes.string.isRequired,
  loggedIn: PropTypes.bool.isRequired,
  singleDocument: PropTypes.shape({
    bookmark: PropTypes.bool,
    news_title: PropTypes.string,
    news_date: PropTypes.string,
    source_country: PropTypes.string,
    source_name: PropTypes.string,
    news_type: PropTypes.string,
    news_link: PropTypes.string,
    document_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  tilesOfTypeLinks: PropTypes.arrayOf(
    PropTypes.shape({
      TILE_ID: PropTypes.number,
    })
  ).isRequired,
  singleTopic: PropTypes.shape({
    TOPIC_ID: PropTypes.number,
    TOPIC_SEARCHTAGS: PropTypes.string,
  }).isRequired,
  userRights: PropTypes.shape({
    USER_RIGHT: PropTypes.string,
  }).isRequired,
  showDeleteNewsModal: PropTypes.func.isRequired,
  handlePagination: PropTypes.func.isRequired,
  filterMessagesRestarted: PropTypes.func.isRequired,
  filterFailureMessage: PropTypes.string.isRequired,
  filterSuccessMessage: PropTypes.string.isRequired,
  filtersAreLoading: PropTypes.bool.isRequired,
  filtersTypesAreLoading: PropTypes.bool.isRequired,
  regulatoryStreamLoadedWithError: PropTypes.bool.isRequired,
  regulatoryStreamPaginationError: PropTypes.bool.isRequired,
  regulatoryStreamAreLoading: PropTypes.bool.isRequired,
  top5PublishersAreLoading: PropTypes.bool.isRequired,
  top5CountriesAreLoading: PropTypes.bool.isRequired,
  graphAggregationsAreLoading: PropTypes.bool.isRequired,
  hotTopicsAndBusinessUnitsAreLoading: PropTypes.bool.isRequired,
  filters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  publicationTypesDataSet: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  publisherTypesDataSet: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  countriesDataSet: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  // topicsAndUnitsDataSet: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setCountries: PropTypes.func.isRequired,
  // setTopicsAndUnits: PropTypes.func.isRequired,
  setPublicationTypes: PropTypes.func.isRequired,
  setPublisherTypes: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  // topicsAndUnits: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  publicationTypes: PropTypes.arrayOf(
    PropTypes.shape({ description: PropTypes.string, value: PropTypes.string })
  ).isRequired,
  publisherTypes: PropTypes.arrayOf(
    PropTypes.shape({ description: PropTypes.string, value: PropTypes.string })
  ).isRequired,
  setFromDate: PropTypes.func.isRequired,
  setToDate: PropTypes.func.isRequired,
  setFreeText: PropTypes.func.isRequired,
  setAddNewsModal: PropTypes.func.isRequired,
  preparationOfDataBeforeOperation: PropTypes.func.isRequired,
  setRaiseSaveFilterModal: PropTypes.func.isRequired,
  freeText: PropTypes.string.isRequired,
  multiFilterRadioButtonsValue: PropTypes.string.isRequired,
  setMultiFilterRadioButtonsValue: PropTypes.func.isRequired,
  applyFilter: PropTypes.func.isRequired,
  resetParams: PropTypes.func.isRequired,
  fromDate: PropTypes.instanceOf(Date).isRequired,
  toDate: PropTypes.instanceOf(Date).isRequired,
  setEditNewsModal: PropTypes.func.isRequired,
  setRaiseManageFiltersModal: PropTypes.func.isRequired,
  changeRadioButtonValue: PropTypes.number.isRequired,
  setChangeRadioButtonValue: PropTypes.func.isRequired,
  graphAggregationsTotalAmount: PropTypes.number.isRequired,
  top5Publishers: PropTypes.shape({}).isRequired,
  top5Countries: PropTypes.shape({}).isRequired,
  hotTopics: PropTypes.shape({}).isRequired,
  hotBusinessUnits: PropTypes.shape({}).isRequired,
  regulatoryStream: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  graphAggregationsDetailsFormatted: PropTypes.arrayOf(PropTypes.array)
    .isRequired,
  setSortField: PropTypes.func.isRequired,
  setPage: PropTypes.func.isRequired,
  addLink: PropTypes.func.isRequired,
  tiles: PropTypes.arrayOf(
    PropTypes.shape({
      TILE_ID: PropTypes.number,
    })
  ),
  setSubmitNewsOccurred: PropTypes.func.isRequired,
  // setAskAQuestionModal: PropTypes.func.isRequired,
};

OverviewSmallScreenContainer.defaultProps = {
  bookmarkDocument: () => {},
  unbookmarkDocument: () => {},
  userToken: "",
  loggedIn: false,
  singleDocument: {},
  singleTopic: {},
  userRights: { USER_RIGHT: "" },
  showDeleteNewsModal: () => {},
  handlePagination: () => {},
  filterMessagesRestarted: () => {},
  filterFailureMessage: "",
  filterSuccessMessage: "",
  regulatoryStreamLoadedWithError: false,
  regulatoryStreamPaginationError: false,
  filtersAreLoading: false,
  filtersTypesAreLoading: false,
  regulatoryStreamAreLoading: false,
  top5PublishersAreLoading: false,
  top5CountriesAreLoading: false,
  graphAggregationsAreLoading: false,
  hotTopicsAndBusinessUnitsAreLoading: false,
  filters: [],
  publicationTypesDataSet: [],
  publisherTypesDataSet: [],
  countriesDataSet: [],
  // topicsAndUnitsDataSet: [],
  setCountries: () => {},
  // setTopicsAndUnits: () => {},
  setPublicationTypes: () => {},
  setPublisherTypes: () => {},
  countries: [],
  // topicsAndUnits: [],
  publicationTypes: [],
  publisherTypes: [],
  setFromDate: () => {},
  setToDate: () => {},
  setFreeText: () => {},
  setEditNewsModal: () => {},
  setAddNewsModal: () => {},
  preparationOfDataBeforeOperation: () => {},
  setRaiseSaveFilterModal: () => {},
  freeText: "",
  multiFilterRadioButtonsValue: "",
  setMultiFilterRadioButtonsValue: () => {},
  applyFilter: () => {},
  resetParams: () => {},
  fromDate: new Date(),
  toDate: new Date(),
  setRaiseManageFiltersModal: () => {},
  changeRadioButtonValue: 0,
  setChangeRadioButtonValue: () => {},
  graphAggregationsTotalAmount: 0,
  top5Publishers: {},
  top5Countries: {},
  hotTopics: {},
  hotBusinessUnits: {},
  regulatoryStream: [],
  graphAggregationsDetailsFormatted: [],
  setSortField: () => {},
  setPage: () => {},
  getTilesOfTypeLinks: () => {},
  tilesOfTypeLinksAreLoading: false,
  tilesOfTypeLinks: [],
  addDocument: () => {},
  addLink: () => {},
  tiles: [],
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OverviewSmallScreenContainer);
